<script setup lang="ts">
import { reactive } from "vue";
import Card from "./Card.vue";

const props = defineProps<{
    accordionContent: { title: string; open: boolean }[]
}>();

const state = reactive({
    accordionContent: props.accordionContent.map(item => ({ ...item })),
});

</script>
<template>
    <Card class="accordion-card">
        <div
            v-for="(item, index) in state.accordionContent"
            :key="index"
            class="accordion-item"
        >
            <div
                class="accordion-item-title-container"
                tabindex="0"
                role="button"
                :aria-expanded="item.open"
                @click="item.open = !item.open"
                @keydown.enter="item.open = !item.open"
                @keydown.space.prevent="item.open = !item.open"
            >
                <h2 class="text-center accordion-item-title">
                    {{ item.title }}
                </h2>
                <img
                    v-if="!item.open"
                    class="accordion-arrow"
                    src="../assets/images/chevron-down.svg"
                    alt="accordion arrow down"
                >
                <img
                    v-if="item.open"
                    class="accordion-arrow"
                    src="../assets/images/chevron-up.svg"
                    alt="accordion arrow up"
                >
            </div>
            <div v-if="item.open">
                <slot :name="`accordion-${index}`" />
            </div>
        </div>
    </Card>
</template>

<style>
.accordion-arrow {
    width: 24px;
    height: 24px;
    margin: 8px;
}

.accordion-item {
    width: 100%;
}

.accordion-item-title {
    margin: 0;
    color: var(--primary-blue);
    font-size: 1.25rem;
}

.accordion-item-title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    width: 100%;
}

.accordion-card {
    width: 100%;
}
</style>
